module.exports = __webpack_public_path__ + "static/media/act-3.e26cfd34.pdf";